import { useBrand } from '@contexts/index'

const FinancialTerms = () => {
  const brand = useBrand()

  const privacyLink =
    brand === 'lexus'
      ? 'https://www.lexus.co.uk/customer-data/privacy-policy'
      : 'https://www.toyota.co.uk/footer/privacy-policy'

  const unsubscribeLink =
    brand === 'lexus'
      ? 'https://forms2.lexus.co.uk/unsubscribe'
      : 'https://forms.toyota.co.uk/unsubscribe'

  return (
    <div className="my-8" data-gt-componentname="terms">
      <p>We will endeavour to respond to your email within 2 working days.</p>
      <br />
      <p>
        Please note that we are only able to discuss details of an agreement
        with the agreement holder. If you wish to discuss a partner/family
        member&apos;s agreement with us, we will need the customer&apos;s
        expressed authority to do this. We will require the customer to contact
        us on{' '}
        <a
          className="underline whitespace-nowrap"
          href={brand === 'lexus' ? 'tel:+443708507788' : 'tel:+443708505533'}
          data-gt-name="ctaevent"
          data-gt-action="terms-click-tel"
          data-gt-label={brand === 'lexus' ? '0370 850 7788' : '0370 850 5533'}
        >
          {brand === 'lexus' ? '0370 850 7788' : '0370 850 5533'}
        </a>{' '}
        and provide details of the third party&apos;s name, date of birth and a
        password, which will be used to identify them.
      </p>
      <br />

      <p>
        {brand === 'lexus'
          ? 'Lexus Financial Services '
          : 'Toyota Financial Services (UK) PLC '}
        will use and process your personal data to assist you with and manage
        the matter that you have contacted us about.
      </p>
      <br />
      <p>
        Information about our use and handling of personal information, your
        data protection rights and how to contact us is provided in our{' '}
        <a
          className="underline whitespace-nowrap"
          href={privacyLink}
          target={'_blank'}
          rel={'noopener noreferrer'}
          data-gt-name="ctaevent"
          data-gt-action="terms-click-link"
          data-gt-label={privacyLink}
        >
          privacy notice
        </a>
        .
      </p>
      <br />
      <p>
        You can withdraw or change any of your communications preferences at any
        time. To do this please contact our{' '}
        <a
          className="underline"
          href="tel:+443708505533"
          data-gt-name="ctaevent"
          data-gt-action="terms-click-link"
          data-gt-label="03708505533"
        >
          Customer Experience Team
        </a>{' '}
        or complete our{' '}
        <a
          className="underline"
          href={unsubscribeLink}
          target={'_blank'}
          rel={'noopener noreferrer'}
          data-gt-name="ctaevent"
          data-gt-action="terms-click-link"
          data-gt-label={unsubscribeLink}
        >
          form
        </a>
        .
      </p>
    </div>
  )
}

export default FinancialTerms
